import { defineComponent as n, openBlock as a, createBlock as r, unref as p, mergeProps as v, withCtx as d, createElementVNode as l } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const f = /* @__PURE__ */ n({
  name: "IconBluetooth",
  __name: "IconBluetooth",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (c, e) => (a(), r(p(u), v(t, { "view-box": "0 0 24 24" }), {
      default: d(() => [...e[0] || (e[0] = [
        l("path", {
          "fill-rule": "evenodd",
          d: "M11.083 7.56v3.063L8.917 9.176a.75.75 0 0 0-.833 1.248L10.444 12l-2.36 1.576a.75.75 0 0 0 .833 1.248l2.166-1.447v3.062c0 1.057 1.23 1.637 2.046.965l2.33-1.922a1.25 1.25 0 0 0-.102-2.004L13.145 12l2.212-1.478a1.25 1.25 0 0 0 .102-2.004l-2.33-1.922c-.816-.672-2.046-.092-2.046.965m1.5 3.011v-2.48l1.662 1.37-1.662 1.11m0 5.338v-2.48l1.662 1.11-1.662 1.37",
          "clip-rule": "evenodd"
        }, null, -1),
        l("path", {
          "fill-rule": "evenodd",
          d: "M5.5 3.25A2.25 2.25 0 0 0 3.25 5.5v13a2.25 2.25 0 0 0 2.25 2.25h13a2.25 2.25 0 0 0 2.25-2.25v-13a2.25 2.25 0 0 0-2.25-2.25h-13M4.75 5.5A.75.75 0 0 1 5.5 4.75h13a.75.75 0 0 1 .75.75v13a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1-.75-.75v-13",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
